import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ThemeProvider, injectGlobal } from 'styled-components';

import theme, { injectGlobalStyles } from './theme';
import './index.css';

import NavigationOverlay from '../components/modules/NavigationOverlay';

require('typeface-yeseva-one');
require('typeface-pt-sans');

injectGlobalStyles(injectGlobal);

class TemplateWrapper extends PureComponent {
  static propTypes = {
    children: PropTypes.func,
  };

  render() {
    const { children } = this.props;
    return (
      <ThemeProvider theme={theme}>
        <div>
          <NavigationOverlay />
          <Helmet
            title="Tom Allen Photo"
            meta={[
              { name: 'description', content: 'Tom Allen Photo' },
              {
                name: 'keywords',
                content: 'Photography, UK, Landscape, Cityscape, Animals',
              },
            ]}
          />
          <div>{children()}</div>
        </div>
      </ThemeProvider>
    );
  }
}

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js